<script>
    import Alert from "$lib/components/ui/Alert.svelte";
    import {onMount} from "svelte";
    import {user} from "$lib/stores/auth";
    import {goto} from "$app/navigation";

    onMount(() => {
        if (!$user?.scope?.includes('/')){
            goto($user.scope[0])
        }
    })
</script>

<h2 class="text-coolGray-700 text-lg">Aktuelle Projekte</h2>
<Alert title="Keine laufenden Projekte"/>

<h2 class="mt-5 text-coolGray-700 text-lg">Kommende Projekte</h2>
<Alert title="Nichts in der Pipeline!"
       content={'<a class="underline" href="/create/project">Neue Projektanfrage</a>'}/>

